import React, { Component } from 'react';
import ideaService from '../services/ideaService.js';

class IdeaVotes extends Component {
  state = {
    votes: [],
    idea: { title: '', module: '', description: '' }
  };
  async componentDidMount() {
    await this.loadData();
  }
  async loadData() {
    const idea = await ideaService.getIdea(this.props.ideaId);
    const votes = await ideaService.getIdeaVotes(idea.id);
    this.setState({
      idea: {
        title: idea.title,
        module: idea.module,
        description: idea.description
      },
      votes: votes.data.votes
    });
  }
  render() {
    return (
      <div className="p-0">
        <div className="text-muted">Votes</div>
        <div className="d-none">
          <h3>
            {this.state.idea.title}{' '}
            <span className="badge badge-success">
              {this.state.idea.module}
            </span>
          </h3>
          <div className="text-muted">{this.state.idea.description}</div>
        </div>
        <ul>
          {this.state.votes.map(vote => (
            <li key={vote.fullName + vote.voted}>
              {vote.fullName}{' '}
              <span className="badge badge-success">{vote.company}</span>{' '}
              <span className="text-muted">
                {new Date(vote.voted).toLocaleDateString() +
                  ' ' +
                  new Date(vote.voted).toLocaleTimeString()}
              </span>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default IdeaVotes;
